import type { ArticleConversionCtaEntry } from 'schema';
import { ArticleConversionCta } from './ArticleConversionCta';

export const ContentfulArticleConversionCta = (
  props: ArticleConversionCtaEntry,
) => <ArticleConversionCta {...props} />;
